import { IInformationMessage } from "@faire/web-api/indigofair/data/IInformationMessage";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";
import styled, { css } from "styled-components";

import { getSettingInternationalBuyingNudges } from "@faire/retailer/settings/getSettingInternationalBuyingNudges";

export const PromoIcon: React.FC<Partial<IInformationMessage>> = ({
  icon_url,
}) => {
  if (icon_url) {
    return (
      <>
        <PromotionIcon
          src={icon_url}
          $offset={getSettingInternationalBuyingNudges() ? undefined : 2}
          $size={getSettingInternationalBuyingNudges() ? 18 : undefined}
        />
        <Spacer size="2x" />
      </>
    );
  }
  return null;
};

const PromotionIcon = styled.img<{
  $size?: number;
  $offset?: number;
}>`
  width: ${(props) => props.$size ?? 24}px;
  height: ${(props) => props.$size ?? 24}px;
  ${(props) =>
    props.$offset
      ? css`
          position: relative;
          bottom: ${props.$offset}px;
        `
      : ""}
`;
